import { createSelector } from 'reselect'
import * as Auth from '../constants/auth.constant'
import { User } from '../interfaces/user'

export interface State {
  isAuthenticated: Boolean
  isSigningIn: Boolean
  isSigningOut: Boolean
  error: string
  Result: Boolean
  user: User
}

export const initialState: State = {
  isAuthenticated: false,
  isSigningIn: false,
  isSigningOut: false,
  error: '',
  Result: false,
  user: null,
}

const auth = (state: any = initialState, action: any) => {
  switch (action.type) {
    case Auth.PROCESS_SIGN_IN:
      return {
        ...state,
        isSigningOut: false,
        Result: null,
      }
    case Auth.DONE_SIGN_IN:
      return {
        ...state,
        isSigningIn: true,
        isSigningOut: false,
        user: action.payload,
      }
    case Auth.PROCESS_SIGN_OUT:
      return {
        ...state,
        isSigningOut: action.isSigningOut,
        Result: action.result,
      }
    case Auth.DONE_SIGN_OUT:
      return {
        ...state,
        isSigningIn: false,
        isSigningOut: true,
      }
    case Auth.DONE_GET_SESSION:
      return {
        ...state,
        isSigningIn: true,
        user: action.payload,
      }
    default:
      return state
  }
}

//
// Selector
//
export const getState = state => state.auth
export const getAuthState = createSelector(getState, (state: State) => state)

export default auth



// WEBPACK FOOTER //
// ./src/reducers/auth.reducer.ts